import "../../styles/Footer.css";
import logo1 from "../../assets/footerLogo.png";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Top Header */}
      <div className="footer-top-head">
        <div className="marquee">
          <h1>LET'S CONNECT L&R GREEN INDIA</h1>
          <h1>LET'S CONNECT L&R GREEN INDIA</h1>
          <h1>LET'S CONNECT L&R GREEN INDIA</h1>
        </div>
        <div className="footer-divider"></div>
      </div>

      {/* Main Footer */}
      <div className="footer-content">
        {/* Company */}
        <div className="footer-brand">
          <div className="footer-logo-row">
            <Link to="/">
              <img src={logo1} alt="L & R Enterprises" />
            </Link>
          </div>

          <p className="footer-desc">
            L &amp; R Enterprises is a leading manufacturer of prefabricated
            structures, mild steel containers and prefabricated cabins since
            2015 in New Delhi, India.
          </p>

          <div className="footer-social">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Info */}
        <div className="footer-col">
          <h4>Info</h4>

          <Link className="footer-link" to="/">
            Home
          </Link>

          <Link className="footer-link" to="/about">
            About Us
          </Link>

          <Link className="footer-link" to="/products">
            Our Products
          </Link>

          <Link className="footer-link" to="/gallery">
            Gallery
          </Link>

          <Link className="footer-link" to="/brochure">
            Brochure
          </Link>

          <Link className="footer-link" to="/contact">
            Contact Us
          </Link>
        </div>

        {/* Legal */}
        <div className="footer-col">
          <h4>Legal</h4>

          <Link className="footer-link" to="/privacy-policy">
            Privacy Policy
          </Link>

          <Link className="footer-link" to="/terms">
            Terms &amp; Conditions
          </Link>

          <Link className="footer-link" to="/travel-policy">
            Travel Policy
          </Link>
        </div>

        {/* Contact */}
        <div className="footer-col contact-col">
          <h4>Contact Info</h4>

          <p className="contact-text">
            <strong>L &amp; R Enterprises</strong>
          </p>

          <a className="contact-link" href="tel:+918595351363">
            +91 8595351363
          </a>

          <a className="contact-link" href="tel:+919758813668">
            +91 9758813668
          </a>

          <a className="contact-link" href="mailto:info.lr1995@gmail.com">
            info.lr1995@gmail.com
          </a>

          <p className="contact-text">GSTIN : 07CLKPG8942A1Z5</p>

          <a
            className="contact-link"
            href="https://maps.google.com/?q=216/2,Gautam+Nagar,New+Delhi+110049"
            target="_blank"
            rel="noopener noreferrer"
          >
            216/2, Gautam Nagar,
            <br />
            Gulmohar Enclave,
            <br />
            New Delhi - 110049,
            Delhi, India
          </a>
        </div>

        {/* Help */}
        <div className="footer-col">
          <h4>Help</h4>

          <Link className="footer-link" to="/support">
            Support
          </Link>

          <Link className="footer-link" to="/faq">
            FAQs
          </Link>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} L &amp; R Enterprises. All Rights
          Reserved.
        </p>

        <p>
          Designed &amp; Developed By{" "}
          <a
            className="developer-link"
            href="https://yuvocreations.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Yuvocreations.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;